<template>
  <div class="quotes">
    <div v-for="(quote, index) in quotes">
      <p>{{quote.text}}</p>
    </div>
  </div>
</template>

<script>
  import { deliveryClient } from '@/kontent.js'

  export default {
    name: 'quotes',
    data: function() {
      return {
        quotes: []
      }
    },
    created: function(){
      var query = deliveryClient
      .items()
      .type('quote')
      .toPromise()
      .then(response => {
        this.$data.quotes = response.items.map(item => ({
          text: item.quote.value
        }))
      })
    }
  }
</script>
